export enum ProductName {
  UNKNOWN = 'unknown',
  LAWYER = 'lawyer',
  LAKIMIES = 'lakimies',
  PROFESSIONAL = 'professional',
  HELSINKI = 'helsinki',
}

export enum ProductActivationType {
  UNKNOWN = 'unknown',
  ACTIVATED = 'activated',
  TEST = 'test',
  HISTORY = 'history',
}

export interface ISystemInfo {
  productName: ProductName;
  productVersion: string;
  activationType: ProductActivationType;
  onlineCustomer: boolean;
}

export interface ISystemInfoResponseDto {
  systemInfo: ISystemInfo;
  apiVersion: string;
  featureFlags?: IFeatureFlags;
}
export interface IFeatureFlags {
  preliminaryInvoice?: IFeatureFlag;
}

export interface IFeatureFlag {
  version: string;
  date?: string;
  description?: string;
}
